module.exports = __webpack_public_path__ + "img/floor_f14_01.5d55239b.png";